import { render, staticRenderFns } from "./PatientIncidentsInfo.vue?vue&type=template&id=11677eda&"
import script from "./PatientIncidentsInfo.vue?vue&type=script&lang=js&"
export * from "./PatientIncidentsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports